import React, { useState, useEffect } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import form from "../../assets/visa/form1.jpg";
import { useNavigate } from "react-router-dom";
import { useCreateVisaContactMutation } from '../../store/api/contact'

const Visa = () => {

    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        address: '',
        age: '',
        gender: '',
        visaType: '',
        travel: '',
        travelStartDate: '',
        travelEndDate: '',
        reasonForTravel: '',
        pastVisaRejections: '',
        fastTrackServices: false,
    });
    const [createVisaContact, { isLoading, isError, isSuccess, error }] = useCreateVisaContactMutation();
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };
    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (isSuccess) {
            setShowSuccess(true);
            const timer = setTimeout(() => setShowSuccess(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [isSuccess]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const submissionData = {
                full_name: formData.fullName,
                phone_number: formData.phoneNumber,
                address: formData.address,
                age: parseInt(formData.age),
                gender: formData.gender,
                visa_type: formData.visaType,
                travel_alone: formData.travel,  // Make sure you have this field in your form
                travel_start_date: formData.travelStartDate,
                travel_end_date: formData.travelEndDate,
                reason_for_travel: formData.reasonForTravel,
                past_visa_rejections: formData.pastVisaRejections,
                fast_track_services: formData.fastTrackServices,
            };

            const result = await createVisaContact(submissionData).unwrap();
            console.log("Form submitted successfully:", result);

            setFormData({
                fullName: "",
                phoneNumber: "",
                address: "",
                age: "",
                gender: "",
                visaType: "",
                travelAlone: "",
                travelStartDate: "",
                travelEndDate: "",
                reasonForTravel: "",
                pastVisaRejections: "",
                fastTrackServices: false,
            });


        } catch (error) {
            console.error("Failed to submit form:", error);
            alert("Failed to submit application. Please try again.");
        }
    };

    return (
        <section>
            <div className="py-24 px-8  ">
                <div className="min-h-screen flex items-center justify-center">
                    <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full ">
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                            <div className="md:flex md:flex-col md:justify-center px-4 py-4 md:px-10 md:py-0 mb-5" >
                                <div className="flex justify-start mb-12">
                                    <button
                                        type="button"
                                        onClick={() => { navigate('/visas') }}
                                        className="bg-[#5B656F] hover:bg-[#3a4558] text-white text-sm md:text-sm font-medium md:py-2 py-2 md:px-4 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1 md:gap-2"                                    >
                                        <MdOutlineKeyboardBackspace className="text-base  md:text-sm" />
                                        Back
                                    </button>
                                </div>

                                <h1 className="md:text-3xl text-2xl font-bold font-[Raleway] text-gray-900 mb-2">
                                    Visa Application
                                </h1>
                                <p className="text-gray-600 mb-8 font-[Rufina]">
                                    Please fill out the form below with your information
                                </p>
                                <form onSubmit={handleSubmit} className="space-y-6  font-[Raleway]">
                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Full Name
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="tel"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Phone Number
                                            </label>
                                        </div>
                                    </div>

                                    <div className='grid sm:grid-cols-2 gap-4'>
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Address
                                            </label>
                                        </div>
                                        <div className="grid sm:grid-cols-2 gap-4">
                                            <div className="relative">
                                                <input
                                                    type="number"
                                                    name="age"
                                                    value={formData.age}
                                                    onChange={handleChange}
                                                    className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                    required
                                                />
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Age
                                                </label>
                                            </div>
                                            <div className="relative">
                                                <select
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                    className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                    required
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="other">Other</option>
                                                </select>
                                                <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                    Gender
                                                </label>
                                                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col sm:grid sm:grid-cols-2 gap-4">
                                        <div className="relative flex-1">
                                            <select
                                                name="visaType"
                                                value={formData.visaType}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg bg-white focus:outline-none focus:border-gray-600 px-3 py-3 text-[10px] appearance-none"
                                                required
                                            >
                                                <option value="">Select Visa Type</option>
                                                <option value="tourist">Tourist</option>
                                                <option value="business">Business</option>
                                                <option value="student">Student</option>
                                                <option value="work">Work</option>
                                            </select>
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Visa Type
                                            </label>
                                        </div>

                                        <div className="relative flex-1">
                                            <input
                                                type="text"
                                                name="travel"
                                                value={formData.travel}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Travel (alone/with others?)
                                            </label>
                                        </div>
                                    </div>

                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div className="relative">
                                            <input
                                                type="date"
                                                name="travelStartDate"
                                                value={formData.travelStartDate}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] "
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Travel Start Date
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="date"
                                                name="travelEndDate"
                                                value={formData.travelEndDate}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] "
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Travel End Date
                                            </label>
                                        </div>
                                    </div>

                                    <div className="relative">
                                        <textarea
                                            name="reasonForTravel"
                                            value={formData.reasonForTravel}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            required
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            Reason for Travel
                                        </label>
                                    </div>

                                    <div className="relative">
                                        <textarea
                                            name="pastVisaRejections"
                                            value={formData.pastVisaRejections}
                                            onChange={handleChange}
                                            rows="2"
                                            className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px] resize-none"
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            Past Visa Rejections (if any)
                                        </label>
                                    </div>

                                    <div className="flex items-center">
                                        <input
                                            type="checkbox"
                                            name="fastTrackServices"
                                            checked={formData.fastTrackServices}
                                            onChange={handleChange}
                                            id="fastTrack"
                                            className="w-4 h-4 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-400"
                                        />
                                        <label htmlFor="fastTrack" className="ml-2 text-sm text-gray-700">
                                            Fast Track Services
                                        </label>
                                    </div>

                                    {error && (
                                        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
                                            Error: {error.data?.message || "Submission failed"}
                                        </div>
                                    )}
                                    {showSuccess && (
                                        <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                                            Form submitted successfully!
                                        </div>
                                    )}

                                    <button
                                        type="submit"
                                        className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                    >
                                        Submit Application
                                        <FiArrowUpRight className="text-xl" />

                                    </button>
                                </form>
                            </div>
                            <div className="hidden lg:flex items-center justify-center">
                                <div className="relative w-full h-full min-h-[400px]">
                                    <img
                                        src={form}
                                        alt="Travel form"
                                        className="w-full h-full object-fit rounded-tr-[40px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visa;
